import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { NeuroConstants } from '../store/neuro.constants'
import { getNeuroSelector } from '../selectors'
import { INeuroState } from '../store/neuro.types'
import { getPcrIdSelector } from '../../../home/selectors'
import { getServiceIdSelector } from '../../../user/selectors'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { IPcr } from '../../../pcr/store/pcr.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* saveDtBaselineSeen() {
  const neuro: INeuroState = yield select(getNeuroSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  try {
    if (pcrID) {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const { dtBaselineSeen } = neuro

      const prNegative = pcrDoc.prNegative || []
      const obj = {
        name: 'Unable to Complete',
        element: 'eSituation.18',
        code: 8801023,
      }

      let updatedPrNegativeData = [...prNegative]
      if (dtBaselineSeen === null) {
        updatedPrNegativeData.push(obj)
      } else {
        updatedPrNegativeData = updatedPrNegativeData.filter((item: any) => item.code !== 8801023)
      }

      const pcrDocUpdated: IPcr = {
        ...pcrDoc,
        prNegative: updatedPrNegativeData,
      }

      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    }
  } catch (e) {
    yield put(throwPcrException(`saveDtBaselineSeen() error: ${e}`))
  }
}

export function* saveDtBaselineSeenSaga() {
  yield takeLatest([NeuroConstants.SAVE_DTBASELINESEEN], performWithMutexHOG, saveDtBaselineSeen)
}
